





















































































































































































import { useCustomersStore } from "@/store/useCustomersStore";
import { BFormCheckbox, BFormGroup, BFormInput, BModal, BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import i18n from "@/libs/i18n";
import ToastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import { ref } from "@vue/composition-api";

export default {
    components: { BFormInput, BFormGroup, BFormCheckbox, BModal, BButton },
    setup(props, context) {
        const { customerSettings, editableCustomerSettings } = storeToRefs(useCustomersStore());
        const { migrateMessageBirdChannels, syncWhatsappTemplates } = useCustomersStore();
        const bvModal = context.root.$bvModal;
        const toast = useToast();
        const isMigrating = ref(false);
        const isSyncing = ref(false);

        editableCustomerSettings.value.push("embeddedSignupLimit");
        editableCustomerSettings.value.push("birdEmbeddedSignupLimit");
        editableCustomerSettings.value.push("flowsLimit");
        editableCustomerSettings.value.push("chatwootLimit");
        editableCustomerSettings.value.push("aiEnabled");
        editableCustomerSettings.value.push("aiConversations");
        editableCustomerSettings.value.push("appsEnabled");
        editableCustomerSettings.value.push("appsLimit");

        const showMigrateModal = () => {
            bvModal
                .msgBoxConfirm(i18n.t("confirm.Are you sure?"), {
                    title: i18n.t("confirm.Are you sure?"),
                    cancelTitle: i18n.t("confirm.Cancel"),
                    cancelVariant: "light",
                    okTitle: i18n.t("confirm.Yes, migrate"),
                    hideHeaderClose: false,
                    headerCloseVariant: "light",
                    centered: true,
                })
                .then((result) => {
                    isMigrating.value = true;
                    if (result) {
                        migrateMessageBirdChannels()
                            .then(() => {
                                toast({
                                    component: ToastificationContent,
                                    props: {
                                        title: i18n.t("settings.system.card-title"),
                                        text: i18n.t("settings.system.saving.success"),
                                        icon: "check",
                                        variant: "success",
                                    },
                                });
                            })
                            .catch(() => {
                                toast({
                                    component: ToastificationContent,
                                    props: {
                                        title: i18n.t("settings.system.card-title"),
                                        text: i18n.t("settings.system.saving.error"),
                                        icon: "cross",
                                        variant: "danger",
                                    },
                                });
                            })
                            .finally(() => {
                                isMigrating.value = false;
                            });
                    }
                });
        };

        const syncTemplates = () => {
            isSyncing.value = true;
            syncWhatsappTemplates()
                .then(() => {
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: i18n.t("settings.system.card-title"),
                            text: i18n.t("settings.system.saving.success"),
                            icon: "check",
                            variant: "success",
                        },
                    });
                })
                .catch(() => {
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: i18n.t("settings.system.card-title"),
                            text: i18n.t("settings.system.saving.error"),
                            icon: "cross",
                            variant: "danger",
                        },
                    });
                })
                .finally(() => {
                    isSyncing.value = false;
                });
        };

        return {
            customerSettings,
            showMigrateModal,
            isMigrating,
            syncTemplates,
            isSyncing,
        };
    },
};
